import { render } from "./UiDeleteButton.vue?vue&type=template&id=7afb78aa"
import script from "./UiDeleteButton.vue?vue&type=script&lang=js"
export * from "./UiDeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__